import styled from "styled-components";
import {SIZES} from "@/components/constants";

const LocationSection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <h2 className={"location-title"} dangerouslySetInnerHTML={{__html: data["main-location-text"]}}/>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3166.2788827465647!2d127.12003367623684!3d37.47774477206181!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca5f4d82c590d%3A0x5c8133d7713981b8!2z6rCA65Og7YyM7J2067iMIOybjeyKpA!5e0!3m2!1sko!2skr!4v1761721496388!5m2!1sko!2skr"
                    height="560"
                    style={{width: "100%", border: 0, borderRadius: 40}}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="googleMap"
                />
                <div className={"location-info"}>
                    <div className={"info-box-wrap no-cu"}>
                        <h5 className={"box-wrap-title"} dangerouslySetInnerHTML={{__html: data["main-address-text"]}}/>
                        <p dangerouslySetInnerHTML={{__html: data["main-address"]}}/>
                    </div>
                    <div className={"info-box-wrap"} onClick={() => {
                        window.open("mailto:info@syntrovalley.com", "_blank", "noopener,noreferrer");
                    }}>
                        <div>
                            <h5 className={"box-wrap-title"} dangerouslySetInnerHTML={{__html: data["main-email-text"]}}/>
                            <p dangerouslySetInnerHTML={{__html: data["main-email"]}}/>
                        </div>
                    </div>
                    <div className={"info-box-wrap"} onClick={() => {
                        window.location.href = `tel:025797708`;
                    }}>
                        <div>
                            <h5 className={"box-wrap-title"} dangerouslySetInnerHTML={{__html: data["main-tel-text"]}}/>
                            <p dangerouslySetInnerHTML={{__html: data["main-tel"]}}/>
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 120px 0;
    background-color: #f1f3f7;

    .container{
        padding: 0 24px;   
        gap: 40px;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin: 0 auto;
        .location-title{
            line-height: 28px;
            font-weight: 700;
            font-size: 18px;
        }
        .location-info{
            display: grid;
            //grid-template-columns: 1fr 1fr;
            gap: 20px;
            width: 100%;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            .info-box-wrap{
                cursor: pointer;
                overflow: hidden;
                border: 1px solid #dfdfe1;
                display: flex;
                width: 100%;
                flex-direction: column;
                gap: 16px;
                background-color: #fff;
                padding: 24px 24px;
                border-radius: 24px;
                &.no-cu{
                    cursor: default;
                }
                .box-wrap-title{
                    font-size: 20px;
                    line-height: 28px;
                    text-transform: uppercase;
                    font-weight: 700;
                    text-align: center;
                }
                p{
                    color: rgba(95, 93, 103, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
            .location-info{
                .info-box-wrap {
                    p{
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
            .location-info{
                grid-template-columns: repeat(3, minmax(0, 1fr));
                gap: 24px;
                .info-box-wrap {
                    padding: 40px 24px;
                    border-radius: 40px;
                    .box-wrap-title{
                        font-size: 24px;
                        line-height: 32px;
                    }
                    p{
                        font-size: 16px;
                        line-height: 24px;
                        min-height: 80px;
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        .container {
            max-width: 1024px;
            padding: 0 40px;
            .location-title{
                line-height: 64px;
                font-size: 40px;
            }
            .location-info {
                .info-box-wrap {
                    .box-wrap-title {
                        font-size: 28px;
                    }

                    p {
                        font-size: 18px;
                        line-height: 28px;
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
        }
    }
    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default LocationSection;
